export const SF_BASE_URL = 'https://cinco.my.salesforce.com';

// Merk = herkomst (zie src/lib/merk.ts). De satellietsites krijgen een eigen
// kleur omdat ze een eigen acquisitiekanaal zijn; wie het werk uitvoert is een
// andere vraag en wordt afgeleid, niet gekleurd.
export const BRAND_COLORS: Record<string, string> = {
  KLEDA: 'bg-emerald-100 text-emerald-700',
  CINCO: 'bg-blue-100 text-blue-700',
  SCHOONHUISSHOP: 'bg-teal-100 text-teal-700',
  SOFASAVER: 'bg-orange-100 text-orange-700',
  VLOERKLEEDREINIGEN: 'bg-lime-100 text-lime-700',
  BANKREINIGEN: 'bg-sky-100 text-sky-700',
};

export const ORDER_STATUS_COLORS: Record<string, string> = {
  // Bestaand (filter-overzicht)
  'Ophalen ingepland': 'bg-blue-100 text-blue-700',
  'In wasserij': 'bg-amber-100 text-amber-700',
  'Klaar voor aflevering': 'bg-emerald-100 text-emerald-700',
  'Afleveren ingepland': 'bg-indigo-100 text-indigo-700',
  'Afgerond': 'bg-slate-100 text-slate-500',
  'Geannuleerd': 'bg-red-100 text-red-600',
  // Wachten / planning (amber/slate)
  'Wachten op adresgegevens': 'bg-amber-100 text-amber-700',
  'Wachten info klant': 'bg-amber-100 text-amber-700',
  'Wachtend op betaling': 'bg-amber-100 text-amber-700',
  'Ophalen plannen': 'bg-slate-100 text-slate-600',
  'Ophaalvoorstel gedaan': 'bg-slate-100 text-slate-600',
  'Terugbrengen plannen': 'bg-slate-100 text-slate-600',
  'Aflevervoorstel gedaan': 'bg-slate-100 text-slate-600',
  'Klaar om ingepland te worden': 'bg-slate-100 text-slate-600',
  'Voorstel afspraak gedaan': 'bg-slate-100 text-slate-600',
  // Actief in workflow
  'Aan het reinigen': 'bg-amber-100 text-amber-700',
  'Bezig': 'bg-amber-100 text-amber-700',
  // On hold
  'On hold': 'bg-orange-100 text-orange-700',
  // Voltooide tussenstappen (blauw)
  'Opgehaald': 'bg-blue-100 text-blue-700',
  'Teruggebracht': 'bg-blue-100 text-blue-700',
  'Zelf gebracht': 'bg-blue-100 text-blue-700',
  'Zelf opgehaald': 'bg-blue-100 text-blue-700',
  'Wordt gebracht': 'bg-blue-100 text-blue-700',
  'Wordt opgehaald': 'bg-blue-100 text-blue-700',
  'Retour ontvangen': 'bg-blue-100 text-blue-700',
  'Terugbetaald': 'bg-blue-100 text-blue-700',
  // Webshop (emerald)
  'Klaarmaken verzending': 'bg-emerald-100 text-emerald-700',
  'Ingepakt': 'bg-emerald-100 text-emerald-700',
  'Verzonden': 'bg-emerald-100 text-emerald-700',
  // Reparatie (orange)
  'Reparatie brengen inplannen': 'bg-orange-100 text-orange-700',
  'Reparatie brengen ingepland': 'bg-orange-100 text-orange-700',
  'Reparatie in uitvoering': 'bg-orange-100 text-orange-700',
  'Reparatie voltooid': 'bg-orange-100 text-orange-700',
  'Reparatie ophalen plannen': 'bg-orange-100 text-orange-700',
  'Reparatie ophalen ingepland': 'bg-orange-100 text-orange-700',
  'Reparatie opgehaald': 'bg-orange-100 text-orange-700',
  // Issue / no-response
  'Ophaalvoorstel geen reactie': 'bg-red-100 text-red-700',
  // Ingepland (indigo)
  'Ingepland': 'bg-indigo-100 text-indigo-700',
  'Levering ingepland': 'bg-indigo-100 text-indigo-700',
  'Ophaling ingepland': 'bg-indigo-100 text-indigo-700',
  'Terugbrengen ingepland': 'bg-indigo-100 text-indigo-700',
};

/** Wasserij_item__c.Status__c kleuren. Volgt de wasserij workflow. */
export const ITEM_STATUS_COLORS: Record<string, string> = {
  'Niet afgeleverd': 'bg-red-100 text-red-700',
  'Opgehaald': 'bg-blue-100 text-blue-700',
  'Geannuleerd': 'bg-red-100 text-red-600',
  'Klaar voor Voorinspectie': 'bg-indigo-100 text-indigo-700',
  'In Vriezer': 'bg-cyan-100 text-cyan-700',
  'Klaar voor Kloppen': 'bg-indigo-100 text-indigo-700',
  'Klaar voor Reinigen': 'bg-amber-100 text-amber-700',
  'Drogen': 'bg-amber-100 text-amber-700',
  'Randen Plakken': 'bg-orange-100 text-orange-700',
  'In Reparatie': 'bg-orange-100 text-orange-700',
  'In Nabehandeling': 'bg-amber-100 text-amber-700',
  'Ingepakt': 'bg-emerald-100 text-emerald-700',
  'Klaargelegd': 'bg-emerald-100 text-emerald-700',
  'In bus': 'bg-indigo-100 text-indigo-700',
  'Afgeleverd': 'bg-slate-100 text-slate-500',
};

/** Filter-opties voor /orders pagina. Lege string = "alle". */
export const ORDER_BRAND_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Alle merken' },
  { value: 'KLEDA', label: 'Kleda' },
  { value: 'CINCO', label: 'Cinco' },
  { value: 'SCHOONHUISSHOP', label: 'Schoonhuisshop' },
  { value: 'SOFASAVER', label: 'SofaSaver' },
  { value: 'VLOERKLEEDREINIGEN', label: 'Vloerkleedreinigen.com' },
  { value: 'BANKREINIGEN', label: 'Bankreinigen.nl' },
];

export const ORDER_STATUS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Alle statussen' },
  { value: 'Ophalen ingepland', label: 'Ophalen ingepland' },
  { value: 'In wasserij', label: 'In wasserij' },
  { value: 'Klaar voor aflevering', label: 'Klaar voor aflevering' },
  { value: 'Afleveren ingepland', label: 'Afleveren ingepland' },
  { value: 'Afgerond', label: 'Afgerond' },
  { value: 'Geannuleerd', label: 'Geannuleerd' },
];

export const ORDER_PERIOD_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '30', label: '30 dagen' },
  { value: '90', label: '90 dagen' },
  { value: '365', label: 'Jaar' },
  { value: 'all', label: 'Alle tijd' },
];

export const DEFAULT_ORDER_PERIOD = '90';
